function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAddMediaOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.228.999h2.45v5.323H31v2.45h-5.324v5.323h-2.449V8.771h-5.324V6.322h5.324V1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.093 2.128c-.676 0-1.225.547-1.225 1.224v25.555c0 .677.549 1.225 1.225 1.225h25.555c.675 0 1.224-.548 1.224-1.225V14.874h-2.449v12.82H4.317V4.578H16.07v-2.45H3.093z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.029 15.26l4.598 6.489 3.165-3.538L26 25.008H6l7.029-9.748z",
    fill: props.color
  }));
}

export default SvgIconAddMediaOutline;